export default [
    {
        id : 1,
        name : "Fitness Pro",
        img : require('../assets/images/work (4).png')
    },
    {
        id : 2,
        name : "Hijou Voice",
        img : require('../assets/images/work (2).png')
    },
    {
        id : 3,
        name : "Wesourcia",
        img : require('../assets/images/work (16).png')
    },
    {
        id : 4,
        name : "Brainwave",
        img : require('../assets/images/work (15).png')
    },
    {
        id : 5,
        name : "Al Manarah",
        img : require('../assets/images/work (17).png')
    },
    {
        id : 6,
        name : "Hi Group",
        img : require('../assets/images/work (18).png')
    },
    {
        id : 7,
        name : "DaniTube",
        img : require('../assets/images/work (13).png')
    },
    {
        id : 8,
        name : "TPS Delivery",
        img : require('../assets/images/work (1).png')
    },
    {
        id : 9,
        name : "Foodies",
        img : require('../assets/images/work (3).png')
    },
    {
        id : 10,
        name : "Tarj'Man",
        img : require('../assets/images/work (5).png')
    },
    {
        id : 11,
        name : "Ista RN",
        img : require('../assets/images/work (6).png')
    },
    {
        id : 12,
        name : "Gimesto",
        img : require('../assets/images/work (11).png')
    },
    {
        id : 13,
        name : "Se'ha",
        img : require('../assets/images/work (12).png')
    },
    {
        id : 14,
        name : "Mozikos",
        img : require('../assets/images/work (14).png')
    },
    {
        id : 15,
        name : "Memory Cards",
        img : require('../assets/images/work (8).png')
    },
    {
        id : 16,
        name : "Tic Tac Toe",
        img : require('../assets/images/work (10).png')
    },
    {
        id : 17,
        name : "Finito",
        img : require('../assets/images/work (9).png')
    }
]